module.exports = "<app-full-fact-sheet-page-1-screen></app-full-fact-sheet-page-1-screen>"


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/full-fact-sheet/full-fact-sheet-screen/full-fact-sheet-screen.component.html
// module id = ../../../../../src/app/securities-level/full-fact-sheet/full-fact-sheet-screen/full-fact-sheet-screen.component.html
// module chunks = main